import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { LoginPage } from "#components";
import { useUsername } from "#services";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
});

function RouteComponent() {
  const username = useUsername();

  const { t } = useTranslation();

  if (username === undefined) {
    return <Fragment />;
  } else if (username === null) {
    return <LoginPage name={t("%Login.0%")} stay />;
  } else {
    return <Outlet />;
  }
}
